export default __webpack_public_path__ + "static/media/DNo.25-6.b7b6f31a.jpg";